import { IDanhSachNoTotNghiepActionTypes } from "../../action-types/xet-tot-nghiep/IDanhSachNoTotNghiepActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IDanhSachNoTotNghiepReducer } from "../../reducer-model/xet-tot-nghiep/IDanhSachNoTotNghiepReducer";

const iniState: IDanhSachNoTotNghiepReducer = {
    status: eReducerStatusBase.is_not_initialization,
    danhSachNoTotNghieps: [],
}

export const danhSachNoTotNghiepReducer = (state: IDanhSachNoTotNghiepReducer = iniState, action: IDanhSachNoTotNghiepActionTypes): IDanhSachNoTotNghiepReducer => {
    switch (action.type) {
        case "DANH_SACH_NO_TOT_NGHIEP_LOAD_BY_DOT_XET_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "DANH_SACH_NO_TOT_NGHIEP_LOAD_BY_DOT_XET_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                danhSachNoTotNghieps: action.payload,
            };
        case "DANH_SACH_NO_TOT_NGHIEP_LOAD_BY_DOT_XET_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    }
}